import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AsaxDownloadingService, DownloadModalComponent, DownloadPreparingDataModalComponent} from 'asax-downloading';
import {filter, map, switchMap, tap} from 'rxjs/operators';
import {combineLatest, Observable, Subject} from 'rxjs';
import {AsaxPropertiesService} from 'asax-properties';
import {HttpClient} from '@angular/common/http';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap/modal/modal-ref";

@Component({
  selector: 'asax-header-download-container',
  templateUrl: './download-container.component.html',
  styles: [`
    .download-modal .modal-dialog {
      max-width: 95vw;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class DownloadContainerComponent implements OnInit {
  areThereRowsSelected: Observable<boolean>;

  downloadSubject = new Subject();

  modalPreparingDataRef: NgbModalRef;
  modalDownloadRef: NgbModalRef;

  modalPreparingDataCancel: boolean;

  constructor(private readonly asaxDownloadingService: AsaxDownloadingService,
              private readonly asaxPropertiesService: AsaxPropertiesService,
              private readonly modalService: NgbModal,
              private readonly httpClient: HttpClient,
              private readonly changeDetectorRef: ChangeDetectorRef) {
    this.areThereRowsSelected = combineLatest([
      this.asaxDownloadingService.getObservationsToBeDownloaded(),
      this.asaxDownloadingService.getProjectsToBeDownloaded(),
      this.asaxDownloadingService.getPublicationsToBeDownloaded(),
    ]).pipe(
      map(([observations, projects, publications]) => observations?.length > 0 || projects?.length > 0 || publications?.length > 0)
    );
  }

  ngOnInit() {
    this.downloadSubject.asObservable().pipe(
      tap(() => this.modalPreparingDataCancel = false),
      tap(() => this.modalPreparingDataRef = this.modalService.open(DownloadPreparingDataModalComponent, {centered: true, backdrop: 'static'})),
      tap(() => this.modalPreparingDataRef?.dismissed.pipe(tap(() => this.modalPreparingDataCancel = true)).subscribe()),
      switchMap(() => this.asaxDownloadingService.buildRequestToDownload()),
      switchMap((data) => this.httpClient.post<any>(`${this.asaxPropertiesService.getProperties().requestHandlerNewUrl}/requests`, data)),
      tap(() => this.modalPreparingDataRef?.close()),
      filter(() => !this.modalPreparingDataCancel),
      map((request) => `${this.asaxPropertiesService.getProperties().requestHandlerNewUrl}/?request=${request?.id}`),
      tap(() => this.modalDownloadRef = this.modalService.open(DownloadModalComponent, {centered: true, windowClass: 'download-modal'})),
      tap((url) => this.modalDownloadRef.componentInstance.src = url),
    ).subscribe();
  }

  download() {
    this.downloadSubject.next(undefined);
  }
}
